// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3v724","header":"MessagesList_header__pxFGu","chat":"MessagesList_chat__1CFqv"};